const setZoom = (win) => {
  const MAX_WIDTH = 1200
  if (win.innerWidth < MAX_WIDTH) {
    const ratio = win.innerWidth / (MAX_WIDTH + 40) //(1 / win.devicePixelRatio) * 1.2
    document.body.style.zoom = ratio
  }
}
setZoom(window)
